export class GuiConsts {
}
GuiConsts.components = {
    imageKey: 'Image',
    numericalDisplayKey: 'NumericalDisplay',
    textKey: 'Text',
    hyperlinkKey: 'Hyperlink',
    meterKey: 'Meter',
    pipeKey: 'Pipe',
    switchIndicatorLightKey: 'SwitchIndicatorLight',
    barGraphKey: 'BarGraph',
    /**
     * 切换画面已经改为画面操作
     */
    toggleViewKey: 'ToggleView',
    characterKey: 'Character',
    straightLineKey: 'StraightLine',
    polyLineKey: 'PolyLine',
    rectangleKey: 'Rectangle',
    sectorkey: 'Sector',
    ellipseKey: 'Ellipse',
    datetimeDisplayKey: 'DatetimeDisplay',
    historicalCurveKey: 'HistoricalCurve',
    ringGraphKey: 'RingGraph',
    viewOperationElement: 'ViewOperation',
    polygonKey: 'Polygon',
    videokey: 'Video',
    tableKey: 'Table',
    weatherKey: 'Weather',
};
